/** Immutable release namespace: every workshop byte change requires a new digest. */
export const COMPANION_WORKSHOP_PATH = '/media/companion/workshop-81ac14e0e989/index.html';
